<template>
  <div class="h-full flex flex-col-reverse lg:flex-col lg:relative"
    :class="{ 'document--main__fullscreen': isFullScreen }">
    <div class="lg:absolute relative document--item__active mobile-send-document">
      <div v-show="!loader" class="bg-white pr-2 pl-4 flex items-center">
        <div class="hidden lg:block text-zt-xl text-zt-primary-200 px-4" @click="isFullScreen = !isFullScreen">
          <zt-icon :name="isFullScreen ? 'reduce-outline' : 'expand-outline'" />
        </div>
        <zt-button data-vs-button="send-eform" class="w-full" @click="validEform">{{
          $t('message.documentVisualizerComponent.sendEform') }}</zt-button>
      </div>
    </div>
    <div class="lg:h-full detail--content">
      <vue-loading v-if="loader" :active="loader" color="#4F41A3" :is-full-page="false" />
      <iframe class="h-full w-full" id="documentframe" frameborder="0"></iframe>
    </div>
    <zt-modal max-width="450px" :show-button-close="false" class="rounded" :active="activeSign" @close="cleanModal">
      <template v-if="!disabledSend">
        <template slot="modal-header">
          <div class="w-full bg-zt-primary-200">
            <p class="p-4 text-zt-lg font-medium text-white">
              {{
                $t('message.documentVisualizerComponent.signDialog.signConfort')
              }}
            </p>
          </div>
        </template>
        <div class="px-4 pb-4">
          <ValidationObserver v-slot="{ handleSubmit }">
            <v-form id="sign-document-form" @submit.prevent="handleSubmit(signDocument)" ref="notConfortReasonForm">
              <div>
                <p class="py-4 confirm--label">
                  {{
                    $t(
                      'message.documentVisualizerComponent.signDialog.inputPassword'
                    )
                  }}
                </p>
                <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                  <zt-input data-vs-input="password" type="password" outlined
                    :label="$t('message.loginComponent.languagesVuetify.password')" v-model="passwordModal.userPass"
                    :color="invalid ? 'danger' : 'primary'" />
                  <span v-show="errors[0]" class="text-zt-danger">{{
                    $t('message.loginComponent.validations.passwordRules.requirePass') }}</span>
                </ValidationProvider>
              </div>
              <div v-if="isActionActive(myActions.sendDocumentSigned)">
                <zt-check-box data-vs-check-box="send-email" v-model="showInputEmail"><span class="confirm--label">{{
                  $t("message.homeComponent.sections.send_document_email") }}</span></zt-check-box>

                <div class="pt-4" v-if="showInputEmail">
                  <ValidationProvider rules="required|email" v-slot="{ errors, invalid }">
                    <zt-input data-vs-input="email" outlined label="Mail" ref="email" v-model="userEmail"
                      :color="invalid ? 'danger' : 'primary'" />
                    <span v-show="errors[0]" class="text-zt-danger">
                      {{ $t('message.homeComponent.sections.valid_email_requerid') }}
                    </span>
                  </ValidationProvider>
                  <p class="text-zt-md text-zt-dark-400 pt-2">
                    {{ $t('message.homeComponent.sections.send_valid_email') }}
                  </p>
                </div>
              </div>
            </v-form>
          </ValidationObserver>
        </div>
        <template slot="modal-footer">
          <div class="zt-modal-footer flex justify-end items-center p-4 confirm--footer">
            <zt-button data-vs-button="clean-modal" class="mr-1" outlined @click="cleanModal">{{
              $t('message.DownloadAllDocuments.cancel') }}</zt-button>
            <zt-button data-vs-button="submit" :disabled="disabledSend" type="submit" form="sign-document-form"
              class="ml-1">{{
                $t('message.documentComponent.SignedDocuments.sendDocument')
              }}</zt-button>
          </div>
        </template>
      </template>
      <template v-else>
        <template slot="modal-header">
          <div class="w-full">
            <p class="p-4 text-zt-lg font-medium text-white">
              {{
                $t('message.documentVisualizerComponent.signDialog.signConfort')
              }}
            </p>
          </div>
        </template>
        <div class="p-4">
          <div class="flex items-center mx-auto">
            <div class="flex-none">
              <div slot="icon" class="sign-loader"></div>
            </div>
            <div class="flex-grow">
              <div class="pl-4">
                {{
                  $t(
                    'message.documentVisualizerComponent.loading.loadingMessage'
                  )
                }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </zt-modal>
  </div>
</template>

<script>
import Eforms from '@/apiClient/Eforms'
import { mapState, mapActions, mapGetters } from 'vuex'
import { some } from 'lodash'

export default {
  name: 'DocumentDetailEform',
  data() {
    return {
      myActions: {
        sendDocumentSigned: 98
      },
      eformOk: 3,
      eformImageError1: 12029,
      eformImageError2: 12030,
      eform: '',
      jwtEform: '',
      pwd: '',
      isFullScreen: false,
      activeSign: false,
      showInputEmail: true,
      userEmail: '',
      loader: true,
      disabledSend: false,
      passwordModal: {
        userPass: ''
      }
    }
  },
  computed: {
    ...mapState(['user', 'timerSweetAlert', 'actions']),
    ...mapState('documents', ['document']),
    ...mapGetters(['getUserEmail']),
    isActionActive() {
      return actionId => some(this.actions, { id: actionId.toString() })
    },
    isInboxDocumentActivated() {
      const actions = this.$store.state.actions
      return actions.some(action => action.id === '304')
    },
  },
  async created() {
    this.eform = new Eforms()
    this.userEmail = this.getUserEmail

    const eformResponse = await this.eform.token()

    this.jwtEform = eformResponse.data.results.data[0]

    if (this.jwtEform) {
      this.getEform()
    }
  },
  mounted() {
    const mainIframe = document.getElementById('documentframe')
    mainIframe.onload = () => {
      setTimeout(() => {
        this.loader = false
      }, 1500)
    }
  },
  methods: {
    ...mapActions('documents', ['updateEformSigned']),
    async getEform() {
      const fullName = `${this.user.nombre} ${this.user.apellido}`
      const eformResponse = await this.eform.client.loadUrl(
        this.jwtEform,
        fullName,
        this.document.archivo
      )

      const element = document.getElementById('documentframe')

      if (element !== null) {
        const doc = element.contentWindow.document
        doc.open()
        doc.write(eformResponse.data)
        doc.close()
      }
    },
    cleanModal() {
      this.passwordModal.userPass = ''
      this.activeSign = false
      this.showInputEmail = true
      this.userEmail = this.getUserEmail
      this.reasonSelected = ''
    },
    validEform() {
      const element = document.getElementById('documentframe')
      const iframe = element.contentWindow
      iframe.viewer
        .emit('send')
        .then(result => {
          if (result === this.eformOk) {
            this.activeSign = true
          }
        })
        .catch(error => {
          let message
          if (error === this.eformImageError1) {
            message = this.$t('message.eforms.errors.e12029').toString()
          }
          if (error === this.eformImageError2) {
            message = this.$t('message.eforms.errors.e12030').toString()
          }
          if (message) {
            this.$swal({
              title: this.$t('message.eforms.titles.warning').toString(),
              type: 'warning',
              text: message,
              inputAttributes: {
                autocapitalize: 'off'
              },
              confirmButtonText: this.$t('message.Pickup.accept').toString(),
              showLoaderOnConfirm: false,
              reverseButtons: true,
              confirmButtonColor: '#4f41a3'
            })
          }
        })
    },

    async signDocument() {
      this.disabledSend = true
      const responseValidation = await this.eform
        .validPass(this.passwordModal.userPass)
        .catch(() => {
          this.disabledSend = false
          this.$swal({
            type: 'error',
            title: this.$t(
              'message.documentVisualizerComponent.incorrectPassword'
            )
          })
        })

      if (!responseValidation.data.results.data[0]) {
        throw new Error(responseValidation.data.results.data[0])
      }

      await this.getIdDocAndSign()
      this.disabledSend = false
    },
    async getIdDocAndSign() {
      const eformResponse = await this.eform.getEforms(this.document.archivo)

      if (eformResponse.data.results.data[0]) {
        const reason = 'FIRMADO CONFORME'
        const sendDocument = this.showInputEmail ? 1 : 0
        const email = this.showInputEmail ? this.userEmail : ''

        const response = await this.eform.signDocument(
          this.passwordModal.userPass,
          this.user.aplicacion.id,
          eformResponse.data.results.data[0],
          reason,
          sendDocument,
          email
        )

        if (response.data.code === 200) {
          this.show = false
          this.$swal({
            type: 'success',
            title: this.$t('message.documentVisualizerComponent.firmSuccess'),
            timer: this.timerSweetAlert,
            showConfirmButton: false
          }).then(() => {
            this.updateEformSigned({ inbox: this.isInboxDocumentActivated })
            if (this.$route.path === '/documents/detail') {
              this.$router.replace('/documents')
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.main--container {
  height: calc(100vh - 40px - 64px - 80px - 21px - 40px);
}

.document--item__active {
  top: 10px;
  right: 10px;
}

@media only screen and (max-width: 1023px) {
  .detail--content {
    height: calc(100vh - 160px);
  }

  .mobile-send-document {
    position: fixed;
    bottom: 25px;
    top: inherit;
    width: 100%;
  }
}

.document--main__fullscreen {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;
  height: 100%;
  width: 100%;
}

.sign-loader {
  border: 16px solid #f5f5f5;
  border-top: 16px solid #4f41a3;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
